module.exports = __webpack_public_path__ + "static/media/drink-responsibly.b3c9d9e2.png";